import { Injectable, inject, computed } from '@angular/core';
import { AuthService } from '../../core/auth/auth.service';
import { MasterModule } from '../../features/settings/models/master-module.model';

@Injectable({ providedIn: 'root' })
export class PortalMenuService {
  private readonly auth = inject(AuthService);
  readonly modules = computed<MasterModule[]>(() => {
    return this.auth.access().menus
      .map((module) => ({
        id: module.id, parentId: module.parent_id, moduleName: module.module_name,
        code: module.code, labelKey: module.label_key, route: module.route ?? '',
        icon: module.icon, sortOrder: module.sort_order, isActive: module.is_active, isMenu: module.is_menu,
      }));
  });
}
